module.exports = __webpack_public_path__ + "img/1537309132.80592bc3.jpg";